const VALID_LINK_TYPES = ['a', 'button'];
export const getValidLinkType = type => VALID_LINK_TYPES.includes(type) ? type : 'a';